import { useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { NavigationTutorial } from './NavigationTutorial';
import { BottomNav } from './BottomNav';
import { SidebarUIContext } from './sidebarUI';

export function AppShell() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [tutorialStartSignal, setTutorialStartSignal] = useState(0);

  const sidebarUI = useMemo(
    () => ({
      collapsed: sidebarCollapsed,
      setCollapsed: setSidebarCollapsed,
      mobileOpen,
      setMobileOpen,
    }),
    [sidebarCollapsed, mobileOpen],
  );

  return (
    <SidebarUIContext.Provider value={sidebarUI}>
      {/* Full viewport height, no outer scroll */}
      <div className="flex h-screen overflow-hidden bg-background">
        {/* Mobile backdrop */}
        {mobileOpen && (
          <div
            className="fixed inset-0 z-40 bg-black/50 lg:hidden"
            onClick={() => setMobileOpen(false)}
            aria-hidden
          />
        )}

        {/* Sidebar — fixed height, scrollable if nav overflows */}
        <Sidebar
          collapsed={sidebarCollapsed}
          onToggle={() => setSidebarCollapsed((c) => !c)}
        />

        {/* Right side — topbar sticky, content scrollable */}
        <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
          <Topbar onGuidedNavigationClick={() => setTutorialStartSignal((s) => s + 1)} />
          <main className="min-w-0 flex-1 overflow-y-auto px-4 py-4 pb-[calc(5rem+env(safe-area-inset-bottom))] sm:px-6 sm:py-6 sm:pb-6 md:pb-6">
            <Outlet />
          </main>
        </div>
        <NavigationTutorial startSignal={tutorialStartSignal} />
        <BottomNav />
      </div>
    </SidebarUIContext.Provider>
  );
}
